import { User } from "models/User";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { AppDispatch, RootState } from "store";
import { fetchBatchDetails, updateLiveStreamSettings } from "store/reducers/livestreamSettings";

const SessionDetailsCard = () => {
  const { batchDetails } = useSelector((state: RootState) => state.live.settings);
  const userState = useSelector((state: RootState) => state.auth.user as User);
  const { isLoading } = useSelector((state: RootState) => state.auth);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch<AppDispatch>();
  const queryParams = new URLSearchParams(location.search);
  const batchId = queryParams.get("batchId");

  useEffect(() => {
    if (batchId) {
      dispatch(fetchBatchDetails({ batchId }));
    }
  }, [batchId]);

  if (!batchDetails?.program || !batchDetails?.batch || !batchDetails?.sessions || isLoading) {
    return (
      <div
        className="flex justify-center items-center h-screen bg-transparent px-4"
        style={{
          backgroundImage: `url('/img/joinSessionBackground.png')`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="text-white text-lg">Loading session details...</div>
      </div>
    );
  }

  // const isJoinableNow = (startDate: string, startTime: string, endTime: string) => {
  //   const now = new Date();
  //   const [startHour, startMinute] = startTime.split(":").map(Number);
  //   const [endHour, endMinute] = endTime.split(":").map(Number);

  //   const startDateTime = new Date(startDate);
  //   startDateTime.setHours(startHour, startMinute, 0, 0);

  //   const endDateTime = new Date(startDate);
  //   endDateTime.setHours(endHour, endMinute, 0, 0);

  //   return now >= startDateTime && now <= endDateTime;
  // };

  return (
    <div
      className="flex justify-center items-center h-screen bg-transparent px-4"
      style={{
        backgroundImage: `url('/img/joinSessionBackground.png')`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="w-full max-w-5xl bg-[#212025] text-white p-4 rounded-xl shadow-xl flex flex-col md:flex-row gap-4 overflow-auto max-h-[90vh] backdrop-blur-sm bg-opacity-90">
        {/* Program Card */}
        <div className="w-full md:w-[40%] bg-[#2D2B33] rounded-xl p-4 flex flex-col justify-center text-sm space-y-1">
          <p className="font-semibold text-yellow-400">
            Welcome <span className="text-white">- {userState.name}</span>
          </p>
          <p className="text-yellow-400">
            Programme: <span className="text-white">{batchDetails.program.program_name}</span>
          </p>
          <p className="text-yellow-400">
            Programme Duration: <span className="text-white">{batchDetails.program.training_hours}</span>
          </p>
          <p className="text-yellow-400">
            Batch: <span className="text-white">{batchDetails.batch.batch_name}</span>
          </p>
        </div>

        {/* Session Card */}
        <div className="w-full md:w-[60%] overflow-y-auto pr-1 text-sm space-y-3">
          <h2 className="text-base font-semibold text-yellow-400">Session(s)</h2>

          {batchDetails?.sessions?.length > 0 &&
            batchDetails.sessions.map((session, index) => {
              // const canJoin = isJoinableNow(
              //   session.session_start_date,
              //   session.session_start_time,
              //   session.session_end_time
              // );

              return (
                <div
                  key={index}
                  className="bg-[#313037] px-4 py-2 rounded-md shadow-sm flex flex-col md:flex-row md:items-center md:justify-between text-xs md:text-sm gap-1 md:gap-2"
                >
                  <div className="flex flex-wrap items-center gap-x-4 gap-y-1">
                    <p className="text-yellow-400 font-semibold">
                      Session Name: <span className="text-white font-normal">{session.session_name}</span>
                    </p>
                    <p className="text-yellow-400 font-semibold">
                      Date: <span className="text-white font-normal">{session.session_start_date}</span>
                    </p>
                    <p className="text-yellow-400 font-semibold">
                      Time:{" "}
                      <span className="text-white font-normal">
                        {session.session_start_time} - {session.session_end_time}
                      </span>
                    </p>
                    <p className="text-yellow-400 font-semibold">
                      Status: <span className="text-white font-normal">{session.status}</span>
                    </p>
                  </div>
                  <Link
                    to={`/configuration?sessionId=${session.sessionMappingId}&programId=${batchDetails.program.id}`}
                  >
                    {/* <button
                      disabled={!canJoin}
                      className={`mt-1 md:mt-0 w-[72px] h-[28px] text-xs rounded-md font-semibold  ${canJoin
                          ? "bg-[#7A5AF8] hover:bg-[#6846f5]"
                          : "bg-gray-500 cursor-not-allowed"
                        }`}
                    >
                      Join
                    </button> */}
                    <button onClick={() => dispatch(updateLiveStreamSettings({ sessionLiveFlag: true }))}
                      className={`mt-1 md:mt-0 w-[72px] h-[28px] text-xs rounded-md font-semibold bg-[#7A5AF8] hover:bg-[#6846f5]`}>
                      Join
                    </button>
                  </Link>
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
};

export default SessionDetailsCard;
